import { Navigate } from "react-router"
import DashboardSection from "../modules/providers/sections/dashboard/Dashboard.section"
import TemplatesSection from "../modules/providers/sections/templates/Templates.section"
import ManageSection from "../modules/providers/sections/manage/Manage.section"
import CreationSection from "../modules/providers/sections/manage/sections/creation/Creation.section"
import ProvidersLayout from "../modules/providers/layout/Providers.layout"
import ModulesLayout from "../layout/Modules.layout"

export const modulesRouter = {
  Component: () => <ModulesLayout />,
  children: [
    {  
      path: 'providers',                  
      Component: () => <ProvidersLayout />,
      children: [            
        {
          index: true,
          Component: () => <Navigate to={"dashboard"} replace />
        },
        {                   
          path: 'dashboard',
          Component: () => <DashboardSection />
        },
        {
          path: 'manage',
          children : [
            {
              index: true,
              Component: () => <ManageSection />
            },
            {
              path: 'creation',
              Component: () => <CreationSection />
            }
          ]
        },
        {
          path: 'templates',              
          Component: () => <TemplatesSection />,          
        },
      ]    
    }
  ]
}
